import React, { useRef } from "react";
import SelectedFileName from "./SelectedFileName";

// Stand-in for <input type="file">. The browser's own "No file chosen" text cannot be
// set from code, so an already-saved file (e.g. an existing icon) never showed its
// name. The real input stays hidden, keeping its id for callers that reset its value.
const FileChooser = ({ id, name, accept, onChange, fileName, style }) => {
  const inputRef = useRef(null);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px", minWidth: 0, ...style }}>
      <input
        id={id}
        ref={inputRef}
        type="file"
        name={name}
        accept={accept}
        onChange={onChange}
        style={{ display: "none" }}
      />
      <button
        type="button"
        onClick={() => inputRef.current && inputRef.current.click()}
        style={{
          flexShrink: 0,
          padding: "1px 8px",
          fontSize: "0.85rem",
          color: "#000",
          backgroundColor: "#efefef",
          border: "1px solid #767676",
          borderRadius: "3px",
        }}
      >
        Choose File
      </button>
      {fileName ? (
        <SelectedFileName name={fileName} style={{ maxWidth: "200px" }} />
      ) : (
        <span style={{ fontSize: "0.8rem", color: "#555", whiteSpace: "nowrap" }}>No file chosen</span>
      )}
    </div>
  );
};

export default FileChooser;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/FileChooser.js